'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface RegionDetailsTooltipProps {
  featuredRegionNames: string[];
  excludedRegionNames: string[];
}

export function RegionDetailsTooltip({
  featuredRegionNames,
  excludedRegionNames,
}: RegionDetailsTooltipProps) {
  if (featuredRegionNames.length === 0 && excludedRegionNames.length === 0) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center w-4 h-4 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors flex-shrink-0"
            aria-label="Region details"
          >
            <svg
              className="w-3.5 h-3.5"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <div className="space-y-1.5 text-xs">
            {featuredRegionNames.length > 0 && (
              <div>
                <span className="font-medium text-amber-600">Featured: </span>
                <span>{featuredRegionNames.join(', ')}</span>
              </div>
            )}
            {excludedRegionNames.length > 0 && (
              <div>
                <span className="font-medium text-slate-500">Excluded: </span>
                <span>{excludedRegionNames.join(', ')}</span>
              </div>
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
